import { render, staticRenderFns } from "./No21.vue?vue&type=template&id=32ef300b&scoped=true"
import script from "./No21.vue?vue&type=script&lang=js"
export * from "./No21.vue?vue&type=script&lang=js"
import style0 from "./No21.vue?vue&type=style&index=0&id=32ef300b&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "32ef300b",
  null
  
)

export default component.exports